import tunnel from 'tunnel-rat';

export const ReasoningTunnel = tunnel();
